import React from "react";
import Company from "./companyselect";
import { LoginSuccess } from "../../router/access";
import { LocalStorageKeys } from "../../utils";
import { useNavigate } from "react-router-dom";

class CompanyPaget extends React.Component {
  componentDidMount() {
    if (localStorage.getItem(LocalStorageKeys.authToken)) {
      if (localStorage.getItem(LocalStorageKeys.permission)) {
        this?.props?.history?.push(
          LoginSuccess(
            JSON.parse(localStorage.getItem(LocalStorageKeys.permission))
          )
        );
      }
    }
  }
  render() {
    return <Company />;
  }
}

export default function CompanyPagetParent(props) {
  const navigate = useNavigate();
  return <CompanyPaget {...props} navigate={navigate} />;
}
